import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { appStatus } from "../../../environments/updated";
import { environment } from "../../../environments/environment";
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  currentUrl
  homeSelect: boolean = true
  startSelect: boolean = false
  gedcomSelect: boolean = false
  ordersSelect: boolean = false
  designsSelect: boolean = false
  profileSelect: boolean = false
  newsSelect: boolean = false
  environment = environment
  updated: string = appStatus.updated;
  innerWidth: any;
  @Output()
  closebtnClick: EventEmitter<string> = new EventEmitter<string>()

  constructor(private router: Router, private auth: AuthService) { }

  logout() {
    this.auth.SignOut();
  }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth < 600) {
      this.closebtnClick.emit("close");
    }
    this.currentUrl = this.router.url
    switch (this.currentUrl) {
      case '/dashboard/home':
        this.homeSelect = true;
        this.startSelect = false;
        this.gedcomSelect = false;
        this.ordersSelect = false;
        this.designsSelect = false;
        this.profileSelect = false;
        this.newsSelect = false;
        break;
      case '/dashboard/selection':
        this.homeSelect = false;
        this.startSelect = true;
        this.gedcomSelect = false;
        this.ordersSelect = false;
        this.designsSelect = false;
        this.profileSelect = false;
        this.newsSelect = false;
        break;
      case '/dashboard/gedcom':
        this.homeSelect = false;
        this.startSelect = false;
        this.gedcomSelect = true;
        this.ordersSelect = false;
        this.designsSelect = false;
        this.profileSelect = false;
        this.newsSelect = false;
        break;
      case '/dashboard/orders':
        this.homeSelect = false;
        this.startSelect = false;
        this.gedcomSelect = false;
        this.ordersSelect = true;
        this.designsSelect = false;
        this.profileSelect = false;
        this.newsSelect = false;
        break;
      case '/dashboard/designs':
        this.homeSelect = false;
        this.startSelect = false;
        this.gedcomSelect = false;
        this.ordersSelect = false;
        this.designsSelect = true;
        this.profileSelect = false;
        this.newsSelect = false;
        break;
      case '/dashboard/profile':
        this.homeSelect = false;
        this.startSelect = false;
        this.gedcomSelect = false;
        this.ordersSelect = false;
        this.designsSelect = false;
        this.profileSelect = true;
        this.newsSelect = false;
        break;
      case '/dashboard/news':
        this.homeSelect = false;
        this.startSelect = false;
        this.gedcomSelect = false;
        this.ordersSelect = false;
        this.designsSelect = false;
        this.profileSelect = false;
        this.newsSelect = true;
        break;


      default:
        break;
    }
  }

  clickClose() {
    this.closebtnClick.emit("close");
  }

}
